import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import FanClubStore from 'stores/FanClubStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';
import { addPercentage } from 'utils/helpers';

import FanclubPrice from './FanclubPrice';
import RegularPrice from './RegularPrice';
import styles from './index.css';


const Price = (props) => {
  const { isDiscountActive, item } = props;

  const {
    cost,
    discountCost,
    discountFanclubCost,
    fanClubCost,
  } = item;

  const { isFanClubActive } = FanClubStore;
  const { performerDetails } = ProfileStore;
  const { user: { tokenUpchargePercentage } } = UserStore;
  const { username: performerName } = performerDetails;

  const prices = useMemo(() => {
    let price = cost || 0;
    let discountedPrice = isDiscountActive ? discountCost : 0;

    let fanclubPrice = 0;
    let discountedFanclubPrice = 0;
    if (isFanClubActive) {
      const hasFanClubCost = (
        fanClubCost !== cost ||
        (isDiscountActive && discountFanclubCost > 0)
      );

      fanclubPrice = hasFanClubCost ? fanClubCost : 0;
      discountedFanclubPrice = isDiscountActive ? discountFanclubCost : 0;
    }

    if (
      UserStore.hasCF(allUserGroups.USE_UPCHARGE) &&
      tokenUpchargePercentage
    ) {
      price = addPercentage(price, tokenUpchargePercentage);
      discountedPrice = addPercentage(discountedPrice, tokenUpchargePercentage);
      fanclubPrice = addPercentage(fanclubPrice, tokenUpchargePercentage);
      discountedFanclubPrice = addPercentage(discountedFanclubPrice, tokenUpchargePercentage);
    }

    return {
      price,
      discountedPrice,
      fanclubPrice,
      discountedFanclubPrice,
    };
  }, [
    cost,
    discountCost,
    discountFanclubCost,
    fanClubCost,
    isDiscountActive,
    isFanClubActive,
    tokenUpchargePercentage,
  ]);

  const {
    discountedPrice,
    discountedFanclubPrice,
    fanclubPrice,
    price,
  } = prices;

  return (
    <div className={styles.price}>
      <RegularPrice
        discountedPrice={discountedPrice}
        price={price}
      />
      <FanclubPrice
        discountedFanclubPrice={discountedFanclubPrice}
        fanclubPrice={fanclubPrice}
        performerName={performerName}
      />
    </div>
  );
};

Price.propTypes = {
  isDiscountActive: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
};

export default observer(Price);
